import React, { FC, ReactNode } from 'react';
import { Section } from '../../layout/Section';
import { Layout } from '../../layout/Layout';
import { Grid } from '../../layout/Grid';
import { Block, Container, TextStylesBock } from './TextModule.styles';

export interface SharedProps {
  tagline: string;
  title: string;
}

export type TextModuleProps = SharedProps & {
  blockContent1: ReactNode;
  blockContent2: ReactNode;
  blockContent3: ReactNode;
};

const TextModule: FC<TextModuleProps> = ({
  tagline,
  title,
  blockContent1,
  blockContent2,
  blockContent3,
}) => {
  return (
    <Section>
      <Layout variant="smallWidth">
        <Grid>
          <TextStylesBock>
            <div className="textEyebrow">{tagline}</div>
            <h4>{title}</h4>
            <Container>
              {blockContent1 && <Block>{blockContent1}</Block>}
              {blockContent2 && <Block>{blockContent2}</Block>}
              {blockContent3 && <Block>{blockContent3}</Block>}
            </Container>
          </TextStylesBock>
        </Grid>
      </Layout>
    </Section>
  );
};

export default TextModule;
